<template>
    <div class="widget-hotspots">
        <Widget
            :widget="widget"
            :hasHotspots="true"
            :hotspotsHidden="hotspotsHidden"
            @toggle-hotspots="toggleHotspots"
        />
        <v-expand-transition>
            <v-list
                v-show="!hotspotsHidden"
                class="mt-4 hotspot-list"
            >
                <v-list-item
                    v-for="(configurableTour, index) in widget.configurableTours"
                    :key="`configurableTour-${index}`"
                    :class="{ 'active': widget.active && configurableTour.active }"
                    :ripple="false"
                    link
                >
                    <Widget
                        :widget="configurableTour"
                        @go-to-widget="goToConfigurableTour(widget, configurableTour)"
                    />
                </v-list-item>
            </v-list>
        </v-expand-transition>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import Widget from '@/layout/sidebar/components/Widget';

    export default {
        name: 'WidgetWithConfigurableTour',
        components: {
            Widget
        },
        props: {
            widget: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters('widget', [
                'requestedScene'
            ]),
            hasActiveConfigurableTour() {
                return this.widget.configurableTours.some((el) => el.active);
            }
        },
        data: () => ({
            hotspotsHidden: true,
            hiddenConfigurableTourType: ['light-variation']
        }),
        methods: {
            goToConfigurableTour(widget, configurableTour) {
                this.$emit('go-to-configurable-tour', widget, configurableTour);
            },
            toggleHotspots() {
                if (this.hotspotsHidden) {
                    EventBus.$emit('HideConfigurableToursWidget');
                    this.hotspotsHidden = false;
                } else {
                    EventBus.$emit('HideConfigurableToursWidget');
                }
            }
        },
        mounted() {
            EventBus.$on('HideConfigurableToursWidget', () => this.hotspotsHidden = true);
        },
        watch: {
            requestedScene(newScene, lastScene) {
                if ((lastScene !== null && newScene !== null) && newScene !== lastScene) {
                    var configurableTour = this.widget.configurableTours.filter(configurableTour => configurableTour.scene === newScene);
                    if (configurableTour.length)
                        this.$emit('go-to-configurableTour', this.widget, configurableTour[0]);
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/sidebar/components/WidgetWithConfigurableTour.vue